import * as React from "react";
import styled, { css } from "styled-components";
import { OverlayTrigger, Icon } from "components/common";
const UnknownFieldTitleContainer = styled.div`
  display: flex;
  gap: 5px;
`;
const ErrorIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.variant.warning};
  `
);
const UnknownAttributeTitle = () => /* @__PURE__ */ React.createElement(UnknownFieldTitleContainer, null, "Unknown", /* @__PURE__ */ React.createElement(
  OverlayTrigger,
  {
    overlay: "This attribute is currently not available, because it requires a valid license.",
    placement: "bottom"
  },
  /* @__PURE__ */ React.createElement(ErrorIcon, { name: "error" })
));
export default UnknownAttributeTitle;
